<template>
  <div class="product-list-item" @click="itemClick">
    <img :src="project.image" alt="" :style={height:imgHeight,width:width}>
    <div>{{project.name}}</div>
    <div>{{project.english}}</div>
  </div>
</template>

<script>
  export default {
    name: "ProductListItem",
    props:{
      project:Object,
      imgHeight: {
        type:String,
        default(){
          return " "
        }
      },
      type: String
    },
    data(){
      return{
        width:"350px"
      }
    },
    methods:{
      itemClick(){
        if (this.type === 'product') {
          this.$router.push({
            path:'/detail',
            query:{
              id:this.project.id
            }
          })
        } else {
          this.$router.push({
            path:'/projectDetail',
            query:{
              id:this.project.id
            }
          })
        }

      }
    }
  }
</script>

<style scoped>
  .product-list-item img{
    width: auto;
    height: auto;
    overflow: hidden;
    transition: all 0.6s;
    margin-bottom: 10px;
  }
  .product-list-item div{
    margin: 0;
    text-align: center;
  }
  .product-list-item{
    padding: 20px;
  }
  .product-list-item img:hover{
    transform: scale(1.1);
    cursor:pointer;
  }
</style>
